module.exports = __webpack_public_path__ + "static/images/cover_C3.b314f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C3.png
// module id = 1Xu9
// module chunks = 8